import { Injectable } from '@nestjs/common';
import { Roles } from '../role-entity';
import { RoleDTO } from './role-dto';

@Injectable()
export class RolesAdapter {
  /**
   *
   */
  public convertDtoToEntity(  roleDTO: RoleDTO,  isUpdate: boolean = false ): Roles {
    const role = new Roles();
    role.roleId=roleDTO.roleId;
    role.roleName=roleDTO.roleName;
    role.isActive=roleDTO.isActive==undefined?true:roleDTO.isActive;
    if (isUpdate) {
      role.updatedUser = roleDTO.updatedUser;
    } else {
      role.isActive = true;
      role.createdUser = roleDTO.createdUser;
    }
   return role;
  }
  public convertEntityToDto(rolesObject: Roles): RoleDTO {
    const roleDTO= new RoleDTO;
    roleDTO.roleId = rolesObject.roleId;
    roleDTO.roleName = rolesObject.roleName;
    roleDTO.isActive = rolesObject.isActive;
    roleDTO.createdAt = rolesObject.createdAt;
    roleDTO.updatedAt = rolesObject.updatedAt;
    roleDTO.createdUser = rolesObject.createdUser;
    roleDTO.updatedUser = rolesObject.updatedUser;
    roleDTO.versionFlag = rolesObject.versionFlag;
    return roleDTO;
  }
}
